import React, { useState, useEffect } from 'react';
import {
    getRepositories,
    getExcludedPaths,
    updateExcludedPaths
} from '../../services/apiServices';
import '../../App.css'
import { Col, FloatingLabel, Form, Row } from 'react-bootstrap';


const Configuration = () => {
    const [platform, setPlatform] = useState('');
    const [repos, setRepos] = useState([]);
    const [selectedRepoName, setSelectedRepoName] = useState('');
    const [selectedRepoId, setSelectedRepoId] = useState(null);
    const [excludedPaths, setExcludedPaths] = useState([]);
    const [newPath, setNewPath] = useState('');


    const platforms = [
        { key: 'AzureDevOps', name: 'AzureDevOps' },
        { key: 'BitBucket', name: 'BitBucket' },
        { key: 'GitHub', name: 'GitHub' },
        
    ];

    useEffect(() => {
        const getAllRepos = async () => {
            if (platform) {
                try {
                    const allRepositories = await getRepositories(platform);
                    setRepos(allRepositories || []);
                    setSelectedRepoName('');
                    setSelectedRepoId(null);
                    setExcludedPaths([]);
                } catch (error) {
                    console.error('Error fetching repos:', error);
                    setRepos([]);
                }
            }
        };
        getAllRepos();
    }, [platform]);

    const handleRepoChange = async (e) => {
        const name = e.target.value;
        setSelectedRepoName(name);

        const selected = repos.find(repo => repo.name === name);
        if (selected) {
            setSelectedRepoId(selected.ID);
            try {
                const paths = await getExcludedPaths(selected.ID);
                const pathsList = paths[0]?.excluded_paths;
                setExcludedPaths(Array.isArray(pathsList) ? pathsList : []);
            } catch (error) {
                console.error('Error fetching excluded paths:', error);
                setExcludedPaths([]);
            }
        } else {
            setSelectedRepoId(null);
            setExcludedPaths([]);
        }
    };

    const handleAddPath = () => {
        const trimmed = newPath.trim();
        if (trimmed && !excludedPaths.includes(trimmed)) {
            setExcludedPaths([...excludedPaths, trimmed]);
            setNewPath('');
        }
    };

    const handleRemovePath = (pathToRemove) => {
        setExcludedPaths(excludedPaths.filter(path => path !== pathToRemove));
    };

    const handleSubmit = async () => {
        if (!selectedRepoId) return;

        try {
            await updateExcludedPaths(selectedRepoId, excludedPaths);
            alert('Excluded paths updated successfully.');
        } catch (error) {
            console.error('Error updating excluded paths:', error);
            alert('Failed to update excluded paths.');
        }
    };

    return (
        <div className="configuration-container">
            <div className="header-bar">
                <Form className="config-form-wrapper">
                    <Row>
                        <Col className="mb-3">
                            <FloatingLabel controlId="platform" label="Platform">
                                <Form.Select
                                    value={platform}
                                    onChange={(e) => setPlatform(e.target.value)}
                                    style={{ width: '250px' }}
                                >
                                    <option value="">Select Platform</option>
                                    {platforms.map((eachPlatform) => (
                                        <option value={eachPlatform.key} key={eachPlatform.key}>
                                            {eachPlatform.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>
                        </Col>

                        <Col className="mb-3">
                            <FloatingLabel controlId="repo-select" label="Repository">
                                <Form.Select
                                    value={selectedRepoName}
                                    onChange={handleRepoChange}
                                    style={{ width: '250px' }}
                                >
                                    <option value="">Select Repository</option>
                                    {repos.map((repo) => (
                                        <option key={repo.ID} value={repo.name}>
                                            {repo.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                    </Row>
                </Form>
            </div>

            <div className="excluded-path-controls" style={{ marginBottom: '20px' }}>
                <input
                    type="text"
                    value={newPath}
                    onChange={(e) => setNewPath(e.target.value)}
                    placeholder="Enter path to exclude"
                    disabled={!selectedRepoId}
                    style={{ width: '80%' }}  // Adjust the width of the input box
                />
                <button
                    className="primary-button"
                    onClick={handleAddPath}
                    disabled={!selectedRepoId || !newPath.trim()}
                    style={{ width: '15%' }}  // Adjust the width of the button
                >
                    Add
                </button>
            </div>

            <div className="excluded-paths-section">
                <div className="excluded-paths-container">
                    {excludedPaths.length > 0 ? (
                        excludedPaths.map((path) => (
                            <div className="excluded-path-chip" key={path}>
                                <span className="excluded-path-label">{path}</span>
                                <button
                                    className="remove-chip-button"
                                    onClick={() => handleRemovePath(path)}
                                    disabled={!selectedRepoId}
                                    title="Remove"
                                >
                                    &times;
                                </button>
                            </div>
                        ))
                    ) : (
                        <span className="excluded-path-placeholder">No excluded paths yet</span>
                    )}
                </div>
            </div>

            <div style={{ marginTop: '15px' }}>
                <button
                    className="primary-button submit-button"
                    onClick={handleSubmit}
                    disabled={!selectedRepoId}
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

export default Configuration;
